import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-button-warn-arrow-right',
  templateUrl: './button-warn-arrow-right.component.html',
  styleUrls: ['./button-warn-arrow-right.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonWarnArrowRightComponent {
  @Input() disabled = false;
  element: ElementRef;

  constructor(private elementRef: ElementRef) {
    this.element = elementRef;
  }
}
